const commitments = [
  {
    id: 1,
    title: 'CLINICALLY TESTED',
    description: 'All products undergo dermatological testing'
  },
  {
    id: 2,
    title: 'NATURAL INGREDIENTS',
    description: '100% herbal formulations, zero chemicals'
  },
  {
    id: 3,
    title: 'QUALITY CERTIFIED',
    description: 'GMP & ISO certified manufacturing'
  },
  {
    id: 4,
    title: 'CRUELTY FREE',
    description: 'Never tested on animals. Eco-friendly.'
  }
];

export default commitments;
